<template>
  <div
    v-if="!virtualShow || virtualShow && showDetail && !showDetail.dropship"
    :class="showHome ? 'home' : ''"
    clas="col-md-12">
    <AvailTable
      :product="product"
      :branchAvail="branchAvail"
      :stockFlagInBranch="stockFlagInBranch"
      :invInBranch="invInBranch"
      :home="home"
      :showHome="showHome"/>
  </div>
</template>

<script>
  import {branchAvail} from '../../../../../shared/availability'
  import {stockFlagInBranch, invInBranch} from '../../../../../shared/stockHelpers'
  import AvailTable from './AvailTable.vue'

  export default{
    inject:['env'],
    props: ['virtualShow', 'showDetail', 'activeUom', 'product', 'showHome'],
    components:{
      AvailTable
    },
    computed:{
      branchAvail(){if(this.product) return branchAvail(this.product, this.activeUom)},
      stockFlagInBranch(){return stockFlagInBranch(this.product)},
      invInBranch(){return invInBranch(this.product)},
      home(){return this.$store.getters.homeBranch}
    }
  }
</script>

<style scoped>
  .home{
    position: relative;
    top: 8px;
    left: 3%;
  }
</style>